function createEmblemUrl(
  emblemHost: string,
  emblemState: string,
  projectKey: string,
  qr: boolean,
  login: boolean,
) {
  const params = new URLSearchParams({ projectKey, emblemState });

  if (qr) params.set('qr', 'true');
  if (login) params.set('login', 'true');

  const urlString = `${emblemHost}/redirect?${params.toString()}`;
  return urlString;
}

export default createEmblemUrl;
